var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 124.455,
    height: 120.514,
    viewBox: "0 0 124.455 120.514",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#14ffa1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15e584"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 124.455,
    height: 120.514,
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M122.765,14.529c1.649,3.127,1.678,6.532,1.679,9.931q.013,37.671,0,75.346c-.007,8.88-5.951,14.748-14.792,14.746q-46.694-.011-93.389.018a20.272,20.272,0,0,1-9.271-1.757C1.832,109.458-.039,104.7,0,98.589c.168-25.725.08-51.451.09-77.176,0-6.19,3.06-10.389,8.551-12.95a5.016,5.016,0,0,1,2.03-.517c4.8-.012,9.605.042,14.408.076a23.433,23.433,0,0,0,.219,6.335,9.1,9.1,0,0,0,7.215,7.208,9.078,9.078,0,0,0,9.457-3.276C44.09,15.84,44.3,12.9,44.134,9.9c-.083-1.568.421-2.04,2.024-2.03,9.68.062,19.363.007,29.043.005,1.547,0,3.47-.48,4.544.253,1.345.918.411,3.014.534,4.59a9.67,9.67,0,0,0,6.889,8.747,9.554,9.554,0,0,0,10.469-3.72c1.515-2.056,1.741-4.408,1.766-6.838.034-3.49-.474-2.95,3.054-3,3.955-.051,7.914-.034,11.871-.046a15.94,15.94,0,0,1,8.133,6.093l.379.5ZM4.472,30.183c-.388.152-.3.416-.157.69-.042.773-.119,1.548-.119,2.323q-.011,30.98,0,61.959c0,1.978.057,3.955.088,5.933-.028.048-.088.1-.078.136a1.648,1.648,0,0,0,.145.269c.533,5.351,4.449,8.813,10.043,8.814,31.6.007,63.2-.108,94.8.088,6.661.042,11.177-4.643,11.122-11.226-.182-21.561-.067-43.125-.073-64.688,0-.918-.05-1.835-.076-2.752a.235.235,0,0,0,.007-.326l-.021-.973c.09-.2.014-.274-.189-.253l-.156-.067a4.9,4.9,0,0,0-2.29-.161q-54.593-.019-109.183,0a11.787,11.787,0,0,0-3.771.166Z",
    transform: "translate(0 5.944)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M28.278,3.414c.81,1.961.6,4.024.609,6.066.007,2.969.06,5.942-.012,8.91a6.4,6.4,0,0,1-6.56,6.362,6.469,6.469,0,0,1-6.4-6.337c-.037-.777-.057-1.554-.085-2.331l.005-10.313q.135-.788.267-1.58l-.041.044.3-.412q4.924-6.939,11.414-1.279c.184.285.37.568.554.853Z",
    transform: "translate(12.184 0.001)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M59.211,2.92a11.166,11.166,0,0,1,.936,5.141c-.06,3.314.025,6.632-.035,9.947-.069,3.923-2.739,6.689-6.379,6.721-3.8.034-6.461-2.688-6.586-6.732-.021-.634-.078-1.265-.119-1.9a96.323,96.323,0,0,0,.039-9.88.229.229,0,0,0,.016-.262A6.521,6.521,0,0,1,51.766.322c3.1-.986,5.427.4,7.445,2.6",
    transform: "translate(36.192 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M46.822,82.026A27.211,27.211,0,1,1,74.166,55.16,27.115,27.115,0,0,1,46.822,82.026m.1-48.2A21.036,21.036,0,1,0,47.266,75.9a21.036,21.036,0,0,0-.347-42.071",
    transform: "translate(15.229 21.245)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M38.367,57.966c0-4.877,0-4.877-4.85-4.877-1.2,0-2.408.051-3.608-.021a3.358,3.358,0,0,1-3.41-3.345A3.492,3.492,0,0,1,30.011,46.2c2.26-.1,4.53-.085,6.792-.012,1.191.037,1.635-.345,1.584-1.564-.081-1.977-.027-3.96-.018-5.942.014-2.725,1.363-4.394,3.507-4.364,2.116.032,3.362,1.593,3.378,4.259.012,1.982.083,3.966-.027,5.942-.074,1.341.418,1.718,1.694,1.66,1.906-.088,3.821-.023,5.73-.005,2.846.025,4.4,1.225,4.458,3.419q.09,3.456-4.532,3.493c-1.839.014-3.681.081-5.516,0-1.354-.064-1.911.327-1.83,1.782.119,2.116.065,4.245.014,6.365-.057,2.313-1.428,3.732-3.461,3.693-2.053-.039-3.334-1.44-3.412-3.775-.035-1.06-.005-2.122-.005-3.184",
    transform: "translate(20.393 26.412)",
    fill: "url(#linear-gradient)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.c57bc22bf9ee7fe4fab65987d7a3e7cd.svg";
export { ForwardRef as ReactComponent };